import React, { Component } from 'react'
import { Overlay, Popover } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import ReportLink from '../ReportLink'
import FlyBaseSymbol from '../FlyBaseSymbol'
import { checkStatus, parseJSON } from '../../api/fetch'

import './styles.css'

/* A class for hitlist update flag popover elements.
  Creates a flag icon, colored based on update status, which is a pop-up activation button.
  Also creates and populates the pop-up, and adds machinery to show and hide it.
  THIS COMPONENT WILL RENDER A FLAG WHEREVER IT IS INCLUDED.
  It is the responsibility of the calling code to apply conditional logic to call UpdateFlag
  only when an update is present.
*/

function makeHTMLfrom(json, item) {
  let html = []
  if (item.update_status.match(/new/i))
    return (
      <div id={item.id + '_updates_popover_contents'} className="p-contents">
        <div className="DC-row">see report for details</div>
      </div>
    )
  for (let dc in json) {
    if (!dc.match(/type/i)) {
      let linkHash = json[dc]
      //  let dc_s = ( Object.keys(linkHash).length===1 ) ? '' : 's';
      let c = 1
      let rows = []
      rows.push(
        <div key={item.id + 'DC-header'} className="DC-header">
          <span>
            new <b>{dc}</b> associations
          </span>
        </div>
      )
      for (let id in linkHash) {
        let rowclass = c % 2 ? 'zrow' : ''
        if (id.match(/^(FB|DO|MI|GO|SO|TEXT)/)) {
          //let rowclass = c % 2 ? '' : 'zrow'
          let line = id.match(/^TEXT/) ? (
            <span id={id}> {linkHash[id]} </span>
          ) : (
            <ReportLink id={id}>
              <FlyBaseSymbol symbol={linkHash[id]} />
            </ReportLink>
          )
          rows.push(
            <div key={item.id + '_dcrow_' + c} className={'DC-row ' + rowclass}>
              {line}
            </div>
          )
          //c++
        } /*if (linkHash[id].isArray())*/
        /*else {
          let csObjArr = linkHash[id]
          //let rowclass = c % 2 ? '' : 'zrow'
          let csLinkArray = []
          for (const [i, termObj] of Object.entries(csObjArr)) {
            if (i > 0) csLinkArray.push(<span>&nbsp;|&nbsp;</span>)
            for (const [k, v] of Object.entries(termObj)) {
              csLinkArray.push(
                <ReportLink id={k}>
                  <FlyBaseSymbol symbol={v} />
                </ReportLink>
              )
            } // iterates ONCE to turn a termObj into a report link
          } // iterates through a compound statement, making an array of report links
          rows.push(
            <div key={'cs_row_' + c} className={'DC-row ' + rowclass}>
              {csLinkArray}
            </div>
          )
        }*/
        c++
      }
      if (rows.length>1) {
      html.push(<div key={item.id + '_' + dc}>{rows}</div>)
      }
    }
  }
  return (
    <div id={item.id + '_updates_popover_contents'} className="p-contents">
      {html}
    </div>
  )
}

class UpdateFlag extends Component {
  constructor(props) {
    super(props)
    this.state = {
      target: null,
      show: false,
      hasHTML: false,
      html: <span id={this.props.item.id + '_updates_popover_contents'} />,
    }
    this.updateHTML = this.updateHTML.bind(this)
    this.handleMouseEvent = this.handleMouseEvent.bind(this)
    this.handleHide = this.handleHide.bind(this)
  }

  updateHTML(response) {
    //  console.log(response);
    this.setState({
      html: makeHTMLfrom(response.resultset.result[0], this.props.item),
    })
    this.setState({ hasHTML: true })
  }

  handleMouseEvent(evt) {
    //  console.log("[UpdateFlag:handleMouseEvent] called");
    //  console.log(this.state);
    this.setState({ target: evt.target, show: !this.state.show })
    if (!this.state.hasHTML) {
      //  console.log("clicked on (or moused over) "+this.props.item.id+" update flag");
      const url = '/api/updates/' + this.props.item.id
      //  console.log(url);
      fetch(url, { method: 'GET', credentials: 'same-origin' })
        .then(checkStatus)
        .then(parseJSON)
        .then(this.updateHTML)
    }
  }

  handleHide() {
    this.setState({ show: false })
  }

  render() {
    const { item } = this.props
    let flagClass = item.update_status.match(/new/) ? 'new' : 'updated'
    let tag = item.symbol
    if (item.id.match(/FBrf/)) tag = item.authors
    if (item.id.match(/FBst/)) tag = item.stock_num ? item.stock_num : item.id
    if (item.id.match(/FBig/)) tag = 'interaction'
    if (item.id.match(/^(FBcl|FBgg|FBhh|DO|MI|GO|SO)/))
      tag = item.name.replace(/_/g, ' ')
    let title = item.update_status.match(/updated/) ? (
      <span>
        <i>New data associated with</i> <FlyBaseSymbol symbol={tag} />
      </span>
    ) : (
      <span>New record</span>
    )
    const popover = (
      <Popover
        id={'hitlist_popover_' + item.id + '_updates'}
        title={title}
        style={{ maxWidth: 600 }}
        className="update-popover"
        onMouseLeave={this.handleHide}>
        {this.state.html}
      </Popover>
    )
    return (
      <React.Fragment>
        {/*
         * See list of supported event handlers here.
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes
         *
         * React hooks for handlers.
         * https://facebook.github.io/react/docs/events.html#supported-events
         */}
        <button
          className={'btn btn-link'}
          onClick={this.handleMouseEvent}
          onMouseEnter={this.handleMouseEvent}>
          <FontAwesome className={flagClass} name="flag" />
        </button>

        <Overlay
          show={this.state.show}
          onHide={this.handleHide}
          rootClose
          placement="bottom"
          target={this.state.target}>
          {popover}
        </Overlay>
      </React.Fragment>
    )
  }
}

UpdateFlag.propTypes = {}

export default UpdateFlag
